// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { OperationsQueries } from '../../../../types/server/modules/operations/queries';

export type * from '../../../../types/server/modules/operations/queries';

export const createQueries = ( requests: Requests ): OperationsQueries => ({
  OperationsRunsById: ( id, query, headers ) => { 
          return requests.get( `/operations/runs/${id}`, query, headers ); 
        },
  OperationsRuns: ( params?, headers? ) => {
        return requests.get( `/operations/runs/:id?`, params, headers );
      },
  OperationsRunsSearch: ( params?, headers? ) => {
        return requests.get( `/operations/runs-search/:search?`, params, headers );
      },
  OperationsChangeSetsById: ( id, query, headers ) => { 
          return requests.get( `/operations/change-sets/${id}`, query, headers ); 
        },
  OperationsChangeSets: ( params?, headers? ) => {
        return requests.get( `/operations/change-sets/:id?`, params, headers );
      }
});
